"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _snackbarActions = require("../actions/snackbarActions");
var _modalActions = require("../actions/modalActions");
var snackOverrideMiddleware = function snackOverrideMiddleware(store) {
  return function (next) {
    return function (action) {
      if (action.type === _snackbarActions.ADD_SNACK) {
        var overrideWith = OVERRIDE_ACTION_BY_SNACK_ID[action.payload.id];
        if (overrideWith) {
          return overrideWith(store, next, action);
        }
      }
      return next(action);
    };
  };
};
var OVERRIDE_ACTION_BY_SNACK_ID = {
  transferError: function transferError(store, next, action) {
    if (action.payload.text.toLowerCase() === '102: server error: waiting for 2fa') {
      return store.dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.SEND_REQUEST_2FA));
    } else {
      return next(action);
    }
  }
};
var _default = exports["default"] = snackOverrideMiddleware;